// Libraries
import { Dialog, DialogActions, DialogContent, DialogTitle, Paper } from '@mui/material'

// Components
import CustomButton from '../../../CustomButton/CustomButton'
import MassApprovalTable from '../../../CostumTable/MassApprovalTable/MassApprovalTable'

// Types and Interfaces
import { MassApprovalAPIResponse } from '../../../../../../types/massApproval'
import { TableData } from '../../../../../../types/table'

// Utils
import { useModal } from '../../../../../../store/ModalProvider'

/**
 * ## CustomModalMassApprovalRetry component
 *
 * - @returns {JSX.Element} The rendered CustomModalMassApprovalRetry component
 */
const CustomModalMassApprovalRetry: React.FC = () => {
	const { isOpen, closeModal, modalData, modalHandlers, modalTitle } = useModal()

	if (
		!isOpen ||
		!modalData ||
		!modalHandlers ||
		modalHandlers?.length === 0 ||
		modalTitle !== 'Rever Folhas de Ponto Submetidas sem Alterações'
	) {
		return null
	}

	const [handleRetryFailedApprovals] = modalHandlers

	const massApprovalData = modalData as MassApprovalAPIResponse

	return (
		<Dialog
			sx={{
				minWidth: '600px',
				height: 'fit-content',
				'& .MuiPaper-root.MuiDialog-paper': { maxWidth: 'none !important' },
			}}
			open={isOpen}
			title={modalTitle}
		>
			<Paper
				role='dialog'
				sx={{
					minWidth: '600px',
					height: '100%',
				}}
			>
				<DialogTitle
					id='error-modal-title'
					variant='h6'
					component='h2'
					sx={{
						fontWeight: 600,
						fontSize: '1rem',
						fontFamily: 'Poppins, sans-serif',
						color: 'var(--primary-dark)',
					}}
				>
					{modalTitle}
				</DialogTitle>
				<DialogContent
					sx={{
						height: 'fit-content',
						display: 'grid',
						gap: '1rem',
						paddingBlock: '0 1.5rem',
						paddingInline: '1.5rem',
					}}
				>
					<MassApprovalTable data={massApprovalData as unknown as TableData} />
				</DialogContent>
				<DialogActions
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-end',
						gap: '0.5rem',
					}}
				>
					<CustomButton
						variant='text'
						onClick={closeModal}
						sx={{ marginLeft: 'auto' }}
					>
						Cancelar
					</CustomButton>
					<CustomButton
						onClick={handleRetryFailedApprovals}
						sx={{ marginLeft: 'auto' }}
					>
						Tentar Novamente
					</CustomButton>
				</DialogActions>
			</Paper>
		</Dialog>
	)
}

export default CustomModalMassApprovalRetry
